import { NgModule } from '@angular/core';
import { HasPlansPipe } from './has-plans.pipe';

@NgModule({
    declarations: [HasPlansPipe],
    exports: [HasPlansPipe]
})
export class HasPlansPipeModule {}
